import { render, staticRenderFns } from "./EasyOrdersShow.vue?vue&type=template&id=50978c66&scoped=true"
import script from "./EasyOrdersShow.vue?vue&type=script&lang=js"
export * from "./EasyOrdersShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50978c66",
  null
  
)

export default component.exports